import { render, staticRenderFns } from "./TagDisplay.vue?vue&type=template&id=29dd08be&scoped=true"
import script from "./TagDisplay.vue?vue&type=script&lang=ts"
export * from "./TagDisplay.vue?vue&type=script&lang=ts"
import style0 from "./TagDisplay.vue?vue&type=style&index=0&id=29dd08be&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29dd08be",
  null
  
)

export default component.exports